import http from "src/services/http";
import store from "../index";
import * as types from "src/store/types/usuario";

export const autenticarUsuario = (email, password, navigate, empresa_id) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/api/v2/empresa/usuarios/autenticar`, {
        email,
        password,
        empresa_id,
      })
      .then(
        ({
          data: {
            usuario: { permissoes, ...usuario },
            empresas,
            empresa_atual,
            token,
          },
        }) => {
          if (token) {
            store.dispatch([
              {
                type: types.USUARIO_SET_SELECT_EMPRESA,
                payload: false,
              },
              {
                type: types.USUARIO_SET_USER,
                payload: usuario,
              },
              {
                type: types.USUARIO_SET_PERMISSOES,
                payload: permissoes ? permissoes.split(",") : [],
              },
              {
                type: types.USUARIO_SET_EMPRESAS,
                payload: empresas,
              },
              {
                type: types.USUARIO_SET_EMPRESA_ATUAL,
                payload: empresa_atual,
              },
            ]);
            localStorage.setItem("token", token);
            navigate("/app/dashboard", { replace: true });
          } else {
            store.dispatch([
              { type: types.USUARIO_SET_USER, payload: usuario },
              { type: types.USUARIO_SET_EMPRESAS, payload: empresas },
              { type: types.USUARIO_SET_SELECT_EMPRESA, payload: true },
            ]);
          }

          resolve();
        },
        (e) => {
          reject(e);
        }
      );
  });
};

export const trocar_empresa = (empresa_id) => {
  store.dispatch({ type: types.USUARIO_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http
      .get(`/api/v2/empresa/usuarios/trocar_empresa/${empresa_id}`)
      .then((response) => {
        localStorage.setItem("token", response.data.token);
        store.dispatch([
          {
            type: types.USUARIO_SET_USER,
            payload: response.data.usuario,
          },
          {
            type: types.USUARIO_SET_EMPRESA_ATUAL,
            payload: response.data.empresa_atual,
          },
          { type: types.USUARIO_LOADING, payload: false },
        ]);
        resolve();
      })
      .catch((error) => {
        console.log(error);
        store.dispatch({ type: types.USUARIO_LOADING, payload: false });
        reject();
      });
  });
};

export const alterar_usuario = (data) => {
  store.dispatch({ type: types.USUARIO_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http
      .put(`/api/v2/empresa/usuarios/atualizar`, data)
      .then((response) => {
        store.dispatch([
          { type: types.USUARIO_SET_USER, payload: response.data },
          { type: types.USUARIO_LOADING, payload: false },
        ]);
        resolve();
      })
      .catch((error) => {
        console.log(error);
        store.dispatch({ type: types.USUARIO_LOADING, payload: false });
        reject();
      });
  });
};

export const alterar_senha = (senhas) => {
  return new Promise((resolve, reject) => {
    http
      .patch(`/api/v2/empresa/usuarios/senha`, senhas)
      .then((response) => {
        resolve();
      })
      .catch((error) => {
        reject();
      });
  });
};

export const ativarRecorrencia = (cartao) => {
  const { empresa_atual } = store.getState().usuario;

  return new Promise((resolve, reject) => {
    store.dispatch({ type: types.USUARIO_LOADING, payload: true });
    http.patch("/api/v2/empresa/recorrencia/ativar", cartao).then(
      (resp) => {
        store.dispatch([
          {
            type: types.USUARIO_SET_EMPRESA_ATUAL,
            payload: {
              ...empresa_atual,
              forma_pagto: resp.data.forma_pagto,
              recorrencia_cartao: resp.data.recorrencia_cartao,
            },
          },
          { type: types.USUARIO_LOADING, payload: false },
        ]);
        resolve();
      },
      (error) => {
        console.log(error);
        reject();
      }
    );
    store.dispatch({ type: types.USUARIO_LOADING, payload: false });
  });
};

export const recuperarSenha = (email) => {
  return new Promise((resolve, reject) => {
    store.dispatch({ type: types.USUARIO_LOADING, payload: true });
    http.post('/api/v2/empresa/usuarios/recuperar-senha', { email })
      .then(response => {
        store.dispatch({ type: types.USUARIO_LOADING, payload: false });
        resolve();
      })
      .catch(error => {
        store.dispatch({ type: types.USUARIO_LOADING, payload: false });
        console.log(error);
        reject();
      })
  });
};

export const resetarSenha = (password, token) => {
  return new Promise((resolve, reject) => {
    store.dispatch({ type: types.USUARIO_LOADING, payload: true });
    http.post('/api/v2/empresa/usuarios/resetar-senha', { password, token })
      .then(response => {
        store.dispatch({ type: types.USUARIO_LOADING, payload: false });
        resolve();
      })
      .catch(error => {
        store.dispatch({ type: types.USUARIO_LOADING, payload: false });
        console.log(error);
        reject();
      })
  });
};